(() => {
  const setup = new URLSearchParams(window.location.search).get('setup');
  if (!setup || setup.length > 200) return;
  document.querySelectorAll('[data-partner-setup-form]').forEach(marker => {
    const form = marker.closest('form');
    const subject = form && form.querySelector('[data-partner-setup-subject]');
    if (subject && !subject.value) {
      subject.value = `${marker.dataset.setupSubject}: ${setup}`;
    }
  });
})();
